import * as Sentry from '@sentry/browser';

// TYPES
import { ERROR_FEEDBACK } from '../../types';

// UTILITIES
import findErrorUTL from '../../../utils/findErrorUTL';
import loggerUTL from '../../../utils/loggerUTL';

// LOAD THAILAND API ERRORS TO INPUT FORM
const feedbackTH = (errors, dispatch) => {
  loggerUTL('ERRORS...', errors);
  const inputError = {
    personalInformation: {
    },
    nationalIDNumber: {
    }
  };

  try {
    /* ============================================
              PERSONAL INFORMATION
       ============================================ */
    if (findErrorUTL(errors, 'firstName')) {
      inputError.personalInformation.firstName = `First name ${
        errors.find((item) => item.includes('firstName')).split(':')[1]
      }`;
    }
    if (findErrorUTL(errors, 'lastName')) {
      inputError.personalInformation.lastName = `Last name ${
        errors.find((item) => item.includes('lastName')).split(':')[1]
      }`;
    }
    if (findErrorUTL(errors, 'nationalIDNo')) {
      inputError.nationalIDNumber.nationalIdNo = `National ID No should be ${
        errors.find((item) => item.includes('nationalIDNo')).split(':')[1]
      }`;
    }
  } catch (err) {
    Sentry.captureException(
      'FAILED TO PARES THAILAND VALIDATION ERRORS...',
      JSON.stringify
    )(errors);
  }

  dispatch({
    type: ERROR_FEEDBACK,
    payload: inputError,
  });
};

export default feedbackTH;
